import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { extractParams } from '@marageti/z4-lib';
import { useAuthStore } from '../../store';
import debugPromise from '../../utils/debug-promise';

const Logout = () => {
  const { removeAuthenticatedTraveler } = useAuthStore();
  const { search } = useLocation();

  useEffect(() => {
    debugPromise('logoutContainer:effect.removeAuthenticatedTraveler', removeAuthenticatedTraveler()
      .then(() => {
        const { redirect } = extractParams(search);
        window.location.href = `/login${redirect ? search : ''}`;
      }));
  }, []);

  return null;
};

export default Logout;
